/**
 * Catálogo cerrado de skill IDs (TKT-021).
 *
 * Enum cerrado: ningún Zod schema acepta string libre como skillId.
 *
 * TODO(game-design): nombres canónicos en español de las 3 skills del
 * Deudor Carmesí. Por ahora se mantienen los IDs técnicos en inglés/snake
 * (CLAUDE.md §7 idiom split: identificadores en inglés). Ver `docs/content/skills.md`.
 */
export const SkillId = {
  DeudorCarmesiBasicAttack: 'deudor_carmesi.basic_attack',
  DeudorCarmesiSkill01: 'deudor_carmesi.skill_01',
  DeudorCarmesiDodge: 'deudor_carmesi.dodge',
} as const;

export type SkillIdValue = (typeof SkillId)[keyof typeof SkillId];

export const ALL_SKILL_IDS: readonly SkillIdValue[] = Object.values(SkillId);
